import Vue from 'vue';
import Listbox from 'primevue/listbox';

Vue.component('Listbox', Listbox);
